import { render } from "./JudgeTrainingComparePanel.vue?vue&type=template&id=5888238c&scoped=true"
import script from "./JudgeTrainingComparePanel.vue?vue&type=script&lang=js"
export * from "./JudgeTrainingComparePanel.vue?vue&type=script&lang=js"

import "./JudgeTrainingComparePanel.vue?vue&type=style&index=0&id=5888238c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5888238c"]])

export default __exports__